import { Component, JSXElement } from "solid-js";

export interface HeaderProps {
  children?: JSXElement | undefined;
}

export const Header: Component<HeaderProps> = (props) => {
  return (
    <div class="bg-linear-down-alpha flex items-center justify-between gap-8 p-4">
      <div class="flex flex-auto shrink-0 content-center items-center">
        {props.children ?? null}
      </div>
      <div class="flex-auto shrink-0 grow-0">
        {/* Disabled until hosting solution for ogg found */}
        {/* <Playlist tracks={["bg-1.ogg", "bg-2.ogg"]} /> */}
      </div>
    </div>
  );
};
